import { Box } from "@mui/material";

export const Logo = () => {
  return (
    <Box sx={{ display: "inline" }}>
      <img
        className="logo"
        src={"/spidipay-logo.svg"}
        alt="Logo"
        style={{
          aspectRatio: "104 / 25",
          width: "104px",
        }}
      />
    </Box>
  );
};
